import { EMPTY_ARRAY } from '@e-socna/empty';

export interface CompatibleWorkflowEntry {
  readonly id: string;
  readonly label: string;
}

export interface CompatibleWorkflowGroup {
  readonly entityLabel: string;
  readonly workflows: readonly CompatibleWorkflowEntry[] | null;
}

export interface CompatibleWorkflowFieldConfig {
  readonly field: string;
  readonly entityLabel: string;
  readonly getWorkflow: (id: string) => { label: string } | undefined;
}

export const extractCompatibleWorkflowGroups = (
  raw: unknown,
  configs: readonly CompatibleWorkflowFieldConfig[],
): readonly CompatibleWorkflowGroup[] => {
  if (typeof raw !== 'object' || raw === null) {
    return EMPTY_ARRAY;
  }

  const { compatibilities } = raw as Record<string, unknown>;

  if (typeof compatibilities !== 'object' || compatibilities === null) {
    return EMPTY_ARRAY;
  }

  const compatibilitiesRecord = compatibilities as Record<string, unknown>;

  return configs.flatMap(
    ({
      field,
      entityLabel,
      getWorkflow,
    }): readonly CompatibleWorkflowGroup[] => {
      const ids = compatibilitiesRecord[field];

      if (ids === undefined) {
        return EMPTY_ARRAY;
      }

      if (ids !== null && !Array.isArray(ids)) {
        return EMPTY_ARRAY;
      }

      if (!ids?.length) {
        return [{ entityLabel, workflows: null }];
      }

      const workflows = ids.map((id) => {
        const workflowId = String(id);

        return {
          id: workflowId,
          label: getWorkflow(workflowId)?.label ?? workflowId,
        };
      });

      return [{ entityLabel, workflows }];
    },
  );
};
